module.exports = __webpack_public_path__ + "media/images/comingsoon_900_600-5b02b39eceaf42ecd4edc6ecff3efcb4.jpg";